import api from "../../Http/global-vars";
import { CHEARCH_PARTNERS, FETCH_PARTNERS } from "../types";

export const fetchPartner = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "partenaire/";
    await fetch(url, config)
      .then(async (res) => {
        const data = await res.json();
        // console.log("data categories", data);
        dispatch({
          type: FETCH_PARTNERS,
          payload: data.results.sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};

export const searchPartner = (partners, searchItem, pays) => {
  // posts.filter((x) => console.log("object", x.category.indexOf(2)));

  let data = [];
  // eslint-disable-next-line
  if (searchItem && pays) {
    data = partners?.filter(
      (user) =>
        (user?.prenom?.toLowerCase()?.includes(searchItem) ||
          user?.nom?.toLowerCase()?.includes(searchItem)) &&
        user?.pays === pays
    );
  } else if (!searchItem && pays) {
    data = partners?.filter((user) => user?.pays === pays);
  } else if (searchItem && !pays) {
    data = partners?.filter(
      (user) =>
        user?.prenom?.toLowerCase()?.includes(searchItem) ||
        user?.nom?.toLowerCase()?.includes(searchItem)
    );
  }

  // console.log("voir", searchItem, data);
  // return "";
  return (dispatch) => {
    dispatch({
      type: CHEARCH_PARTNERS,
      payload: {
        items:
          !searchItem?.length && !pays
            ? partners?.sort((a, b) => b?.id - a?.id)
            : data?.sort((a, b) => b?.id - a?.id),
      },
    });
  };
};
